import _plugin_vue_export_helper_default from "../../_virtual/_plugin-vue_export-helper.js";
import ScalarDropdownDivider_vue_vue_type_script_lang_default from "./ScalarDropdownDivider.vue.script.js";
import { createElementBlock, openBlock } from "vue";
//#region src/components/ScalarDropdown/ScalarDropdownDivider.vue
var _hoisted_1 = { class: "-mx-0.75 my-0.75 h-border bg-border" };
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
	return openBlock(), createElementBlock("div", _hoisted_1);
}
var ScalarDropdownDivider_default = /*#__PURE__*/ _plugin_vue_export_helper_default(ScalarDropdownDivider_vue_vue_type_script_lang_default, [["render", _sfc_render]]);
//#endregion
export { ScalarDropdownDivider_default as default };

//# sourceMappingURL=ScalarDropdownDivider.vue.js.map